export enum AuthModuleConfigId {
  MobileWorker = 'mobile-worker-sts',
  MobileWorkerLocal = 'mobile-worker-local-sts',
  DevincoConnect = 'devinco-connect',
}
